import HttpRequest from "./http_request";
import * as moment from "moment";
import { extractCabinsMaintenanceInfo } from "../utils/cabinsMaintenance";

export default class B2bProvider extends HttpRequest {
  async log(event, payload) {
    try {
      const response = await this.pushLog(event, payload);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async register(body) {
    try {
      const formData = new FormData();
      Object.keys(body).forEach((key) => {
        if (body[key]) {
          if (Array.isArray(body[key])) formData.append(key, JSON.stringify(body[key]));
          else formData.append(key, body[key]);
        }
      });

      const response = await this.post("/v1/auth/register", formData);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async staffRegister(body) {
    try {
      const response = await this.post("/v1/auth/register/staff", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async login(body) {
    try {
      const response = await this.post("/v1/auth/login", body);
      return { data: response?.data, error: null };
    } catch (err) {
      // if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async logout() {
    try {
      const response = await this.post("/v1/auth/logout");
      return { data: response?.data, error: null };
    } catch (err) {
      // if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async forgotPassword(body) {
    try {
      const response = await this.post("/v1/auth/forgot-password", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async resetPassword(body) {
    try {
      const response = await this.post("/v1/auth/reset-password", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async changePassword(body) {
    try {
      const response = await this.post("/v1/auth/change-password", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async refresh() {
    try {
      const response = await this.get("/v1/auth/refresh");
      return { data: response?.data, error: null };
    } catch (err) {
      // if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async validateAccessToken() {
    try {
      const response = await this.get("/v1/auth/validate-access-token");
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async verifyTotp(code, mfaToken) {
    try {
      const response = await this.post("/v1/auth/totp/verify", { code }, { headers: { "mfa-token": `Bearer ${mfaToken}` } });
      return { data: response?.data, error: null };
    } catch (err) {
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async skipTotp(mfaToken) {
    try {
      const response = await this.post("/v1/auth/totp/skip", {}, { headers: { "mfa-token": `Bearer ${mfaToken}` } });
      return { data: response?.data, error: null };
    } catch (err) {
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getTotpSetup(mfaToken) {
    try {
      const response = await this.get("/v1/auth/totp/setup", null, { headers: { "mfa-token": `Bearer ${mfaToken}` } });
      return { data: response?.data, error: null };
    } catch (err) {
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async verifyTotpSetup(code, mfaToken) {
    try {
      const response = await this.post("/v1/auth/totp/setup/verify", { code }, { headers: { "mfa-token": `Bearer ${mfaToken}` } });
      return { data: response?.data, error: null };
    } catch (err) {
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async confirmStaffTotp(code) {
    try {
      const response = await this.post("/v1/auth/totp/staff-confirm", { code });
      return { data: response?.data, error: null };
    } catch (err) {
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async skipStaffTotp() {
    try {
      const response = await this.post("/v1/auth/totp/staff-confirm/skip", {});
      return { data: response?.data, error: null };
    } catch (err) {
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async resetUserTotp(userId, staffActionToken) {
    try {
      const response = await this.delete(
        `/v1/auth/totp/reset/${userId}`,
        null,
        null,
        { headers: { "staff-action-token": `Bearer ${staffActionToken}` } },
      );
      return { data: response?.data, error: null };
    } catch (err) {
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getStaffUsers(params = {}) {
    try {
      const query = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") query.append(key, value);
      });
      const response = await this.get("/v1/users?" + query.toString());
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async adminUpdateUser(id, data, staffActionToken) {
    try {
      const response = await this.update(`/v1/users/${id}/admin`, data, {
        headers: { "staff-action-token": `Bearer ${staffActionToken}` },
      });
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async adminResetUserPassword(id, staffActionToken) {
    try {
      const response = await this.post(`/v1/auth/admin/password-reset/${id}`, {}, {
        headers: { "staff-action-token": `Bearer ${staffActionToken}` },
      });
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getMyTotpStatus() {
    try {
      const response = await this.get("/v1/auth/totp/me");
      return { data: response?.data, error: null };
    } catch (err) {
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getMyTotpSetup() {
    try {
      const response = await this.get("/v1/auth/totp/me/setup");
      return { data: response?.data, error: null };
    } catch (err) {
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async verifyMyTotpSetup(code) {
    try {
      const response = await this.post("/v1/auth/totp/me/setup/verify", { code });
      return { data: response?.data, error: null };
    } catch (err) {
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async disableMyTotp(code) {
    try {
      const response = await this.delete("/v1/auth/totp/me", null, { code });
      return { data: response?.data, error: null };
    } catch (err) {
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async validateSignupToken(token) {
    try {
      const response = await this.get("/v1/auth/validate-signup-token/" + token);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async validateResetPasswordToken(token) {
    try {
      const response = await this.get("/v1/auth/validate-reset-password-token/" + token);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getAdminInvitee() {
    try {
      const response = await this.get("/v1/auth/admin-invitee");
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async sendAdminInvitee(body) {
    try {
      const response = await this.post("/v1/auth/admin-invitee", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async sendMakerInvitee(body) {
    try {
      const response = await this.post("/v1/auth/maker-invitee", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async removeInviteeById(id, forceDeleteUser) {
    try {
      const response = await this.delete(
        "/v1/auth/invitee/id/" + id + (forceDeleteUser ? "?forceDeleteUser=" + !!forceDeleteUser : ""),
      );
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async removeInviteeByEmail(email, forceDeleteUser) {
    try {
      const response = await this.delete(
        "/v1/auth/invitee/email/" + email + (forceDeleteUser ? "?forceDeleteUser=" + !!forceDeleteUser : ""),
      );
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getAgentAdmin() {
    try {
      const response = await this.get("/v1/users/agent/admin");
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getLoginDomains() {
    try {
      const response = await this.get("/v1/config/login-domains");
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getAgentByOrganizationId(organizationId) {
    try {
      const response = await this.get("/v1/users/agent/" + organizationId);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getAgentMakerByOrganizationId(organizationId) {
    try {
      const response = await this.get("/v1/users/agent/maker/" + organizationId);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getCompany(organizationId) {
    try {
      const response = await this.get("/v1/organizations/" + organizationId);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async updateCompany(organizationId, body) {
    try {
      const formData = new FormData();
      Object.keys(body).forEach((key) => {
        if (key === "allowed_login_domains") {
          if (body[key] == null) {
            formData.append(key, "");
          } else if (Array.isArray(body[key])) {
            formData.append(key, JSON.stringify(body[key]));
          }
          return;
        }
        if (body[key] !== null && body[key] !== undefined && body[key] !== "") {
          if (Array.isArray(body[key])) {
            formData.append(key, JSON.stringify(body[key]));
          } else if (typeof body[key] === "object" && !(body[key] instanceof File)) {
            formData.append(key, JSON.stringify(body[key]));
          } else {
            formData.append(key, body[key]);
          }
        }
      });

      const response = await this.update("/v1/organizations/" + organizationId, formData);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async updateUser(userId, body) {
    try {
      const response = await this.update("/v1/users/" + userId, body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async rejectAgentAdmin(body) {
    try {
      const response = await this.post("/v1/organizations/reject", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async approveAgentAdmin(body) {
    try {
      const response = await this.post("/v1/organizations/approve", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getSearchOptions() {
    try {
      const response = await this.get("/v1/search/search-options");
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getKidAgeConfigs() {
    try {
      const response = await this.get("/v1/b2c/kid-age-configs");
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getCruiseItineraries(criteria) {
    try {
      const response = await this.post("/v1/search/cruise-itineraries", criteria);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getCabins(body) {
    try {
      const response = await this.post("/v1/b2c/cabins", body);
      return { data: response?.data, error: null, maintenance: { isMaintenance: false } };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return {
        data: null,
        error: err.response?.data || err.message,
        maintenance: extractCabinsMaintenanceInfo(err),
      };
    }
  }

  async getCabinDetail(body) {
    try {
      const response = await this.post("/v1/b2c/cabins/details", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getFareCodes(body) {
    try {
      const response = await this.post("/v1/b2c/cabins/fare-codes", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getFareOptions(body) {
    try {
      const response = await this.post("/v1/b2c/cabins/fare-options", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }
  async getDinings(body) {
    try {
      const response = await this.post("/v1/b2c/cabins/dinings", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async holdCabin(body) {
    try {
      const response = await this.post("/v1/b2c/cabins/hold", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async releaseCabin(body) {
    try {
      const response = await this.post("/v1/b2c/cabins/release", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async fetchCabinList({ packageUid, stateroomType }, body) {
    try {
      const response = await this.post(`/v1/b2c/cabins/${packageUid}/${stateroomType}`, body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getCodeLists() {
    try {
      const response = await this.get("/v1/b2c/getCodeLists");
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async breakDowns(body) {
    try {
      const response = await this.post("/v1/b2c/cabins/break-downs", body, { timeout: 240000 });
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async confirmBooking(body) {
    try {
      const response = await this.post("/v1/b2c/cabins/confirm", body, { timeout: 240000 });
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getBookingList(body, isOrgLevel = false, queryParams = {}) {
    try {
      const params = new URLSearchParams();
      if (isOrgLevel) params.append("isOrgLevel", "true");
      Object.entries(queryParams || {}).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((each) => {
            if (each !== undefined && each !== null && each !== "") params.append(key, each);
          });
          return;
        }
        if (value !== undefined && value !== null && value !== "") params.append(key, value);
      });
      const queryString = params.toString();
      const url = "/v1/b2c/bookings/lists" + (queryString ? `?${queryString}` : "");
      const response = await this.post(url, body || {});
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getBookingChangeOwnerRequests(params = {}) {
    try {
      const bookingUid =
        params?.bookingUid != null && String(params.bookingUid).trim() !== ""
          ? String(params.bookingUid).trim()
          : "";
      const response = await this.get(
        bookingUid ? `/v1/booking/change-owner/requests?bookingUid=${encodeURIComponent(bookingUid)}` : "/v1/booking/change-owner/requests",
      );
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getOrganizationNetworkList(params = {}) {
    try {
      const query = new URLSearchParams();
      Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") query.append(key, value);
      });
      const qs = query.toString();
      const response = await this.get("/v1/organizations/network/list" + (qs ? `?${qs}` : ""));
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async createBookingChangeOwnerRequest(body) {
    try {
      const response = await this.post("/v1/booking/change-owner/requests", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async approveBookingChangeOwnerRequest(id) {
    try {
      const response = await this.post(`/v1/booking/change-owner/requests/${id}/approve`, {});
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async rejectBookingChangeOwnerRequest(id, reason) {
    try {
      const response = await this.post(`/v1/booking/change-owner/requests/${id}/reject`, { reason });
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async cancelBookingChangeOwnerRequest(id, reason) {
    try {
      const response = await this.post(`/v1/booking/change-owner/requests/${id}/cancel`, { reason });
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getBookingItem(bookingUid) {
    try {
      const response = await this.get("/v1/b2c/bookings/details/" + bookingUid);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getB2BBookingItem(bookingUid) {
    try {
      const response = await this.get("/v1/booking/" + bookingUid);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getQuotationTC() {
    try {
      const response = await this.get("/v1/options/tc/quotation");
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async saveQuotationTC(body) {
    try {
      const response = await this.post("/v1/options/tc/quotation", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getInvoiceTC() {
    try {
      const response = await this.get("/v1/options/tc/invoice");
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async saveInvoiceTC(body) {
    try {
      const response = await this.post("/v1/options/tc/invoice", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getUserById(id) {
    try {
      const response = await this.get("/v1/users/" + id);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getUserIgnore404(id) {
    try {
      const response = await this.get("/v1/users/" + id + "/ignore-404");
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getB2BPayment(bookingUid) {
    try {
      const response = await this.get("/v1/payment/" + bookingUid);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async submitB2BPayment(body) {
    try {
      const formData = new FormData();
      Object.keys(body).forEach((key) => {
        if (body[key]) {
          if (Array.isArray(body[key])) formData.append(key, JSON.stringify(body[key]));
          else formData.append(key, body[key]);
        }
      });

      const response = await this.post("/v1/payment", formData);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async updateB2BPaymentItem(body) {
    try {
      const response = await this.update("/v1/payment/item", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async createPayment(body) {
    try {
      const response = await this.update("/v1/b2c/payments/create", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async confirmPayment(body) {
    try {
      const response = await this.post("/v1/payment/confirm", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async cancelPayment(body) {
    try {
      const response = await this.post("/v1/b2c/payments/cancel", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async confirmCancelPayment(body) {
    try {
      const response = await this.post("/v1/payment/confirm-cancel", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getPaymentInbox(bookingUid) {
    try {
      const url = bookingUid
        ? "/v1/payment/inbox?booking_uid=" + encodeURIComponent(bookingUid)
        : "/v1/payment/inbox";
      const response = await this.get(url);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getPaymentTracking(params = {}) {
    try {
      const qs = new URLSearchParams();
      if (params.booking_uid) qs.set("booking_uid", params.booking_uid);
      if (params.status) qs.set("status", params.status);
      if (params.stuck_at_org_id) qs.set("stuck_at_org_id", params.stuck_at_org_id);
      const suffix = qs.toString() ? "?" + qs.toString() : "";
      const response = await this.get("/v1/payment/tracking" + suffix);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getPaymentItemDetail(paymentId, reservationId, paymentNo) {
    try {
      const response = await this.get(
        `/v1/payment/item/${encodeURIComponent(paymentId)}/${encodeURIComponent(reservationId)}/${encodeURIComponent(paymentNo)}`,
      );
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async approvePaymentTransfer(transferId, body = {}) {
    try {
      const response = await this.post(
        `/v1/payment/transfer/${encodeURIComponent(transferId)}/approve`,
        body,
      );
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async rejectPaymentTransfer(transferId, body) {
    try {
      const response = await this.post(
        `/v1/payment/transfer/${encodeURIComponent(transferId)}/reject`,
        body,
      );
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async forwardPaymentTransfer(body) {
    try {
      const formData = new FormData();
      Object.keys(body).forEach((key) => {
        const value = body[key];
        if (value === undefined || value === null) return;
        if (Array.isArray(value) && value[0] instanceof File) {
          value.forEach((file) => formData.append(key, file));
        } else if (Array.isArray(value)) {
          formData.append(key, JSON.stringify(value));
        } else if (value instanceof File) {
          formData.append(key, value);
        } else {
          formData.append(key, value);
        }
      });
      const response = await this.post("/v1/payment/transfer/forward", formData);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getPaymentRecipientAccount() {
    try {
      const response = await this.get("/v1/payment/recipient-account");
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getPaymentRollbackPreview(bookingUid) {
    try {
      const response = await this.get(
        "/v1/payment/rollback/preview?booking_uid=" + encodeURIComponent(bookingUid),
      );
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async rollbackPaymentChain(body) {
    try {
      const response = await this.post("/v1/payment/rollback", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async reservationReturnStatus(body) {
    try {
      const response = await this.post("/v1/b2c/reservations/return-status", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getQuotation(body, isOpenNewTab = false) {
    try {
      const response = await this.post("/v1/pdf/quotation", body, { responseType: "arraybuffer" });

      let fileURL = "";

      if (response?.data) {
        const file = new Blob([response.data], { type: "application/pdf" });
        fileURL = URL.createObjectURL(file);
        if (isOpenNewTab) {
          const link = document.createElement("a");
          link.href = fileURL;
          link.download = `QO_${body.cruiseLineShortcode}${moment(body.sailDate).format("YYMMDD")}_${moment().format(
            "YYMMDD",
          )}_${moment().format("HHmm")}`;
          link.target = "_blank";
          link.click();
          URL.revokeObjectURL(fileURL);

          // window.open(fileURL);
        }
      }

      if (!response?.data || !fileURL) throw new Error("Quotation is not found!");

      return { data: fileURL, error: null };
    } catch (err) {
      if (err.response?.data) {
        err.response.data = JSON.parse(new TextDecoder().decode(err.response.data));
      }

      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getInvoice(body, isOpenNewTab = true) {
    try {
      const response = await this.post("/v1/pdf/invoice", body, { responseType: "arraybuffer" });

      let fileURL = "";

      if (response?.data) {
        const file = new Blob([response.data], { type: "application/pdf" });
        fileURL = URL.createObjectURL(file);
        if (isOpenNewTab) {
          const link = document.createElement("a");
          link.href = fileURL;
          link.download = `INV_${body.cruiseLineShortcode}${moment(body.sailDate).format("YYMMDD")}_${moment().format(
            "YYMMDD",
          )}_${moment().format("HHmm")}`;
          link.target = "_blank";
          link.click();
          URL.revokeObjectURL(fileURL);

          // window.open(fileURL);
        }
      }

      if (!response?.data || !fileURL) throw new Error("Invoice is not found!");

      return { data: fileURL, error: null };
    } catch (err) {
      if (err.response?.data) {
        err.response.data = JSON.parse(new TextDecoder().decode(err.response.data));
      }

      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getBookingConfirmation(body, isOpenNewTab = true) {
    try {
      const response = await this.post("/v1/pdf/booking-confirmation", body, { responseType: "arraybuffer" });

      let fileURL = "";

      if (response?.data) {
        const file = new Blob([response.data], { type: "application/pdf" });
        fileURL = URL.createObjectURL(file);
        if (isOpenNewTab) {
          const link = document.createElement("a");
          link.href = fileURL;
          link.download = `BK_${body.cruiseLineShortcode}${moment(body.sailDate).format(
            "YYMMDD",
          )}${body.reservationIDs.map((id) => "_#" + id)}`;
          link.target = "_blank";
          link.click();
          URL.revokeObjectURL(fileURL);

          // window.open(fileURL);
        }
      }

      if (!response?.data || !fileURL) throw new Error("Invoice is not found!");

      return { data: fileURL, error: null };
    } catch (err) {
      if (err.response?.data) {
        err.response.data = JSON.parse(new TextDecoder().decode(err.response.data));
      }

      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getAmendmentByBookingUid(booking_uid) {
    try {
      const response = await this.get("/v1/amendment/" + booking_uid);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async createAmendment(body) {
    try {
      const response = await this.post("/v1/amendment", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async recallAmendment(amendment_id) {
    try {
      const response = await this.delete("/v1/amendment/" + amendment_id);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async rejectAmendment(amendment_id, body) {
    try {
      const response = await this.update(`/v1/amendment/${amendment_id}/reject`, body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async approveAmendment(amendment_id, body) {
    try {
      const response = await this.update(`/v1/amendment/${amendment_id}/approve`, body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async reservationChanges(body) {
    try {
      const response = await this.post("/v1/b2c/reservations/confirm-changes", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getAgentCommission() {
    try {
      const response = await this.get("/v1/configuration/AGENT-DEFAULT-COMMISSION");
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getLastCommitUSDRate(booking_uid) {
    try {
      const response = await this.get("/v1/pdf/invoice/usd-rate/" + booking_uid + "/last");
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getExchangeRateByBookingUid(bookingUid) {
    try {
      const response = await this.get("/v1/pdf/invoice/usd-rate/" + bookingUid);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async sendEmailTemplate(body) {
    try {
      const { templateName, ...payload } = body;
      const response = await this.post(`/v1/mail/${templateName}`, payload);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getB2CExchangeRate(body) {
    try {
      const response = await this.post('/v1/b2c/exchange-rates', body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async sendEmailBookingConfirmationB2C(body) {
    try {
      const response = await this.post('/v1/b2c/send-confirmation-email', body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async updateVpsPrice(body) {
    try {
      const response = await this.post('/v1/b2c/update-vps-price', body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getPortDetail(portCode) {
    try {
      this.setHeader({
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${process.env.VUE_APP_B2C_ACCESS_TOKEN}`,
      });

      const response = await this.post("/v1/b2c/get-port-details/" + portCode);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async putDinings(body) {
    try {
      this.setHeader({
        "Content-Type": "application/json",
        Authorization: `Bearer ${process.env.VUE_APP_B2C_ACCESS_TOKEN}`,
      });

      const response = await this.update("/v1/b2c/cabins/dinings", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async putExtraOptions(body) {
    try {
      this.setHeader({
        "Content-Type": "application/json",
        Authorization: `Bearer ${process.env.VUE_APP_B2C_ACCESS_TOKEN}`,
      });

      const response = await this.update("/v1/b2c/cabins/extra-options", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async putGuestDetails(body) {
    try {
      this.setHeader({
        "Content-Type": "application/json",
        Authorization: `Bearer ${process.env.VUE_APP_B2C_ACCESS_TOKEN}`,
      });

      const response = await this.update("/v1/b2c/cabins/guest-details", body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getOrganizationManagementList(params) {
    try {
      const query = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") query.append(key, value);
      });
      const response = await this.get("/v1/organizations/management/list?" + query.toString());
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getOrganizationDetail(orgId) {
    try {
      const response = await this.get("/v1/organizations/" + orgId);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async assignOrganizationChildren(orgId, childrenIds) {
    try {
      const response = await this.post("/v1/organizations/" + orgId + "/children", { children_ids: childrenIds });
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async detachOrganizationChildren(orgId, childrenIds) {
    try {
      const body = childrenIds && childrenIds.length > 0 ? { children_ids: childrenIds } : {};
      const response = await this.delete("/v1/organizations/" + orgId + "/children", null, body);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getOrganizationTree(params = {}) {
    try {
      const query = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") query.append(key, value);
      });
      const response = await this.get("/v1/organizations/management/tree?" + query.toString());
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getMyNetworkTree() {
    try {
      const response = await this.get("/v1/organizations/my-network/tree");
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async updateOrgCommission(orgId, payload) {
    try {
      const response = await this.update("/v1/organizations/" + orgId + "/commission", payload);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async listConfigurations() {
    try {
      const response = await this.get("/v1/configuration");
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getConfiguration(key) {
    try {
      const response = await this.get("/v1/configuration/" + key);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async updateConfiguration(key, value) {
    try {
      const response = await this.patch("/v1/configuration/" + key, { value });
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getBookingAuditLogs(bookingUid, params) {
    try {
      const response = await this.get("/v1/audit-logs/bookings/" + bookingUid, params);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async getSystemAuditLogs(params) {
    try {
      const response = await this.get("/v1/audit-logs", params);
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }

  async createConfiguration(key, value) {
    try {
      const response = await this.post("/v1/configuration", { key, value });
      return { data: response?.data, error: null };
    } catch (err) {
      if (process.env.VUE_APP_NODE_ENV === "development") console.error(err);
      return { data: null, error: err.response?.data || err.message };
    }
  }
}
